import { render, staticRenderFns } from "./ManagingTuitionStatisticChart.vue?vue&type=template&id=650defaa&scoped=true"
import script from "./ManagingTuitionStatisticChart.vue?vue&type=script&lang=js"
export * from "./ManagingTuitionStatisticChart.vue?vue&type=script&lang=js"
import style0 from "./ManagingTuitionStatisticChart.vue?vue&type=style&index=0&id=650defaa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650defaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650defaa')) {
      api.createRecord('650defaa', component.options)
    } else {
      api.reload('650defaa', component.options)
    }
    module.hot.accept("./ManagingTuitionStatisticChart.vue?vue&type=template&id=650defaa&scoped=true", function () {
      api.rerender('650defaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingTuitionStatisticChart.vue"
export default component.exports